module.exports = __webpack_public_path__ + "static/media/whatsappEn.f084135d.svg";